import { allTemporaryData } from './tourData';

const calculateMealplanIngredients = (mealPlan, globalServingSize = 4) => {
    const aggregatedIngredients = {};

    mealPlan.recipes.forEach(recipeInPlan => {
        const plannedServings = parseFloat(recipeInPlan.servingSize) || parseFloat(globalServingSize);
        const originalServings = parseFloat(recipeInPlan.originalServingSize) || parseFloat(recipeInPlan.servingSize) || 4;
        
        if (!plannedServings || !originalServings || originalServings === 0) {
            return;
        }
        
        const ratio = plannedServings / originalServings;

        (recipeInPlan.ingredients || []).forEach(ing => {
            if (!ing.name) return;
            const key = `${ing.name.trim().toLowerCase()}|${(ing.unit || '').trim().toLowerCase()}`;
            const currentAmount = aggregatedIngredients[key] ? aggregatedIngredients[key].amount : 0;
            const newAmount = (parseFloat(ing.amount) || 0) * ratio;

            aggregatedIngredients[key] = {
                name: ing.name,
                unit: ing.unit,
                amount: currentAmount + newAmount,
            };
        });
    });

    if (mealPlan.additionalItems) {
        mealPlan.additionalItems.forEach(item => {
            if (!item.name) return;
            const key = `${item.name.trim().toLowerCase()}|${(item.unit || '').trim().toLowerCase()}`;
            const currentAmount = aggregatedIngredients[key] ? aggregatedIngredients[key].amount : 0;
            
            aggregatedIngredients[key] = {
                name: item.name,
                unit: item.unit,
                amount: currentAmount + (parseFloat(item.amount) || 0),
            };
        });
    }

    return Object.values(aggregatedIngredients);
};

export const getMealplanIngredients = (mealPlan, globalServingSize) => {
    if (mealPlan.title === 'Temporary Meal Plan') {
        const ingredients = calculateMealplanIngredients({ recipes: [allTemporaryData.recipe] }, globalServingSize);
        return Promise.resolve(ingredients);
    }
    const ingredients = calculateMealplanIngredients(mealPlan, globalServingSize);
    return Promise.resolve(ingredients);
};

// Mock other API functions to prevent any real backend calls during the tour.
// They return resolved promises with empty or default data.
export const getRecipes = () => Promise.resolve([allTemporaryData.recipe]);
export const findRecipesByIngredients = () => Promise.resolve([]);
export const addRecipeAPI = (recipe) => Promise.resolve({ ...recipe, id: `temp-recipe-${Date.now()}` });
export const updateRecipeAPI = (id, recipe) => Promise.resolve({ ...recipe, id });
export const deleteRecipeAPI = () => Promise.resolve();

export const getCookbooks = () => Promise.resolve([allTemporaryData.cookbook]);
export const addCookbookAPI = (cookbook) => Promise.resolve({ ...cookbook, id: `temp-cookbook-${Date.now()}` });
export const updateCookbookAPI = (id, cookbook) => Promise.resolve({ ...cookbook, id });
export const deleteCookbookAPI = () => Promise.resolve();

export const getCategories = () => Promise.resolve([allTemporaryData.category]);
export const addCategoryAPI = (category) => Promise.resolve({ ...category, id: `temp-category-${Date.now()}` });
export const updateCategoryAPI = (id, category) => Promise.resolve({ ...category, id });
export const deleteCategoryAPI = () => Promise.resolve();

export const getIngredients = () => Promise.resolve(allTemporaryData.ingredients);
export const addIngredientAPI = (ingredient) => Promise.resolve({ ...ingredient, id: `temp-ingredient-${Date.now()}` });
export const updateIngredientAPI = (id, ingredient) => Promise.resolve({ ...ingredient, id });
export const deleteIngredientAPI = () => Promise.resolve();

export const getMealplans = () => Promise.resolve([]);
export const addMealplanAPI = (mealPlan) => Promise.resolve({ ...mealPlan, id: `temp-mealplan-${Date.now()}` });
export const updateMealplanAPI = (id, mealPlan) => Promise.resolve({ ...mealPlan, id });
export const deleteMealplanAPI = () => Promise.resolve();

export const getFaqs = () => Promise.resolve([]);

export const autoSaveMealPlan = () => Promise.resolve();
export const clearAutoSavedMealPlan = () => Promise.resolve();